import React from 'react';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import {Button, Divider, LinearProgress, useMediaQuery,} from '@material-ui/core';
import {DescriptionCta} from 'components/molecules';
import {Section} from 'components/organisms';
import {invokeQuery, pageQuery} from "api/graphCmsApi";
import {Markdown} from "components/atoms";
import {formatDate} from "common";

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
        width: '100%',
        '& .description-cta__button-group': {
            flexWrap: 'nowrap',
        },
    },
    pagePaddingTop: {
        paddingTop: theme.spacing(3),
        [theme.breakpoints.up('md')]: {
            paddingTop: theme.spacing(5),
        },
    },
    fontWeightBold: {
        fontWeight: 'bold',
    },
    divider: {
        margin: theme.spacing(3, 0),
        [theme.breakpoints.up('md')]: {
            margin: theme.spacing(5, 0),
        },
    }
}));

const DynamicCmsPage = (props) => {
    const classes = useStyles();
    const {slug = 'terms-of-service'} = props
    console.log("Looking for ", slug, props);

    const [page, setPage] = React.useState();

    React.useEffect(() => {
        async function loadPage() {
            const response =
               await invokeQuery(pageQuery(slug));

            if (response.ok) {
                const result = await response.json();
                setPage(result.data.page);
            } else
                console.error("Missing page");
        }

        loadPage()
    }, [slug])

    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    if (!page)
        return <LinearProgress/>

    return (
       <div className={classes.root}>
           <Section className={classes.pagePaddingTop}>
               <>
                   <DescriptionCta
                      title={page.title}
                      subtitle={`Updated on ${formatDate(new Date(page.updatedAt))}`}
                      primaryCta={
                          <Button variant="outlined" color="primary" size="large" onClick={()=>window.print()}>
                              Print
                          </Button>
                      }
                      align={'left'}
                      titleProps={{
                          className: classes.fontWeightBold,
                          color: 'textPrimary',
                      }}
                      subtitleProps={{
                          color: 'textSecondary',
                      }}
                   />
                   <Divider className={classes.divider}/>
                   <Markdown>
                       {page.content.markdown}
                   </Markdown>
               </>
           </Section>
           <Divider/>
       </div>
    );
};

export default DynamicCmsPage;
